import localeRouting from '@/config/localeRouting.json';

/**
 * Pages that support localization (all other pages will use English only).
 * Single source of truth: config/localeRouting.json
 * Used by HreflangTags, middleware-related logic, and language selector visibility.
 */
export const LOCALIZED_PAGES: readonly string[] = localeRouting.localizedPages;
